import {
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';

import { AdjustersSection, ClaimsSection, SubrogatorSection } from './claims';
import { CoverageFormData } from './types';

interface ClaimsInfoTabProps {
  register: UseFormRegister<CoverageFormData>;
  setValue: UseFormSetValue<CoverageFormData>;
  watch: UseFormWatch<CoverageFormData>;
  claimFields: FieldArrayWithId<CoverageFormData, 'claims', 'id'>[];
  appendClaim: UseFieldArrayAppend<CoverageFormData, 'claims'>;
  removeClaim: UseFieldArrayRemove;
  onRemoveClaim?: (index: number) => void;
  removingClaimIndex?: number | null;
  adjusterFields: FieldArrayWithId<CoverageFormData, 'adjusters', 'id'>[];
  appendAdjuster: UseFieldArrayAppend<CoverageFormData, 'adjusters'>;
  removeAdjuster: UseFieldArrayRemove;
}

export const ClaimsInfoTab = ({
  register,
  setValue,
  watch,
  claimFields,
  appendClaim,
  removeClaim,
  onRemoveClaim,
  removingClaimIndex,
  adjusterFields,
  appendAdjuster,
  removeAdjuster,
}: ClaimsInfoTabProps) => {
  return (
    <div className="space-y-6">
      <ClaimsSection
        register={register}
        setValue={setValue}
        watch={watch}
        claimFields={claimFields}
        appendClaim={appendClaim}
        removeClaim={removeClaim}
        onRemoveClaim={onRemoveClaim}
        removingClaimIndex={removingClaimIndex}
      />

      <AdjustersSection
        register={register}
        setValue={setValue}
        watch={watch}
        adjusterFields={adjusterFields}
        appendAdjuster={appendAdjuster}
        removeAdjuster={removeAdjuster}
      />

      <SubrogatorSection
        register={register}
        setValue={setValue}
        watch={watch}
      />
    </div>
  );
};
